<template>
  <div class="bg">
    <div class="header">
      <div>
        <div class="year">2026</div>
        <title_button :state="state"></title_button>
        <div class="tips"><p v-for="tip in tips">{{tip}}</p></div>
      </div>
    </div>
  </div>
</template>
<script>
import FPTitle from '@/components/frontpage/Title.vue';
import TitleButton from '@/components/frontpage/TitleButton.vue';
import MyButton from '@/components/Button.vue';
import Logos from '@/components/frontpage/TitleLogo.vue';
import moment from 'moment';

export default {
  name: 'FPHeader',
  props: {
  },
  computed: {
    moment () {
      return moment
    },
    canAccess () {
      if (!this.storeUser) {
        return false
      }
      const now = moment(+new Date() + this.$store.state.timeDelay)
      const classrooms = this.$store.state.classrooms
      if (classrooms.length) {
        const clsTime = moment(classrooms[0].succeeded_at)
        let alreadyStart = false
        this.timeSets.forEach((time) => {
          if (clsTime.isAfter(time.start) && clsTime.isBefore(time.end)) {
            alreadyStart = true
        }})
        if (alreadyStart) {
          const oneHour = 3600000 * 1
          const inContest = now.isBefore(new Date(+clsTime + oneHour))
          if (!inContest) {
            this.state = 'final-end'
          }
          return inContest
        }
        let res = false
        this.timeSets.forEach((time) => {
          if (now.isAfter(time.start) && now.isBefore(time.end)) {
            res = true
          }
        })
        return res
      }
      return false
    },
    videoStyle () {
      return {
        'font-size': '16px',
        'height': '35px',
        'width': '8em',
        'border-radius': '5px'
      }
    },
    title() {
      return this.$store.state.frontpage.title
    },
    passed () {
      if(this.storeUser)
        return this.$store.state.auth.game_state[this.game_year+'-1']?.state > 0
      else
        return false
    },
    game_year() {
      return this.gameSlug.slice(0, 4)
    },
    success () {
      if(this.storeUser)
        return this.$store.state.auth.game_state[this.game_year+'-2'].state == 1
      else
        return false
    },
    moment() {
      return moment
    },
    storeUser() {
      return this.$store.state.auth.user
    },
    myClassroom() {
      if(this.$store.state.classrooms &&
         this.$store.state.classrooms[0])
        return this.$store.state.classrooms[0]
      else
        return undefined
      d
    },
    gameState() {
      return this.$store.state.auth.game_state
    },
    gameSlug() {
      return this.$store.state.game_slug
    },
    procedure() {
      return this.$store.state.procedure
    }
  },
  watch:{
    storeUser(newValue) {
      this.dispatchMatch()
    },
    myClassroom(newValue) {
      if(newValue)
      {
        this.dispatchMatch()
      }
    }
  },
  data () {
    return {
      cc: 0,
      mock: '不模拟',
      state: 'repecharge-end',
      tips: [],
      video: false,
      timeSets: [
        { start: '2026-08-15 09:45:00', end: '2026-08-15 11:00:00' },
      ]
    }
  },
  methods: {
    jumpVideo (main) {
      let link = 'https://live.bilibili.com/21996486'
      link = 'https://www.bilibili.com/video/BV1Q5411N7zj'
      window.open(link, '_blank')
    },
    dispatchMatch () {
      this.state = 'repecharge-end'
      if (this.passed) {
        this.tips = ['您已晋级决赛，请耐心等待比赛开始（8月15日）。']
      } else {
        this.tips = ''
      }
      if (this.canAccess) {
        this.state = 'final-start'
      }
    },
    correctTime() {
      return moment(+new Date() + this.$store.state.timeDelay)
    },
    cfinal (personal) {
      console.log('cfinal' + personal)
      let user = this.storeUser
      let tips = ''
      let state = 'repecharge-end'
      let myClassroom = this.myClassroom
      console.log(this.gameState)
      console.log(this.gameSlug)
      if(user && ((!personal) || this.gameState[this.gameSlug].state != 0)){
        let now = this.correctTime()
        console.log(myClassroom)
        let before30 = moment(myClassroom.begin_time).subtract(30, 'minutes');
        let start = moment(myClassroom.begin_time)
        let end = moment(myClassroom.end_time)
        if(now.isBefore(before30, 'day'))
        {
          tips = '决赛时间：' + before30.format('MM月DD日')
        }
        else if(now.isBefore(before30))
        {
          tips =(personal?'个人赛比赛将于' :  '团体赛比赛将于') + start.format('HH:mm-') + end.format('HH:mm') + '进行，请做好准备'
          state = 'final-prestart-' + (personal? 'personal' : 'group');
        }
        else if(now.isBefore(end))
        {
          state = 'final-start-' + (personal ? 'personal' : 'group')
        }
        else
        {
          state = 'final-end-' + (personal ? 'personal': 'group')
        }
      }
      else{
        tips = '决赛时间：4 月 12 日'
      }
      this.state= state
      this.tips= tips
    },
    crepecharge (nv=undefined) {
      let user = nv || this.storeUser
      let tips = ''
      let state = 'preliminary-end'
      if(user && this.passed)
      {
        // today, before 15min, end,
        if(this.procedure == 2) {
          state = 'final-prestart'
        }
        else if(this.procedure == 3) {
          state = 'final-start'
        }
        else if (this.procedure == 4) {
          if(this.reward){
            state = 'reward-start'
          }
          else
            state = 'final-end'
        }
      }
      /* else
       *   {
       *     tips = '决赛时间：1月23日-2月6日'
       *   } */
      this.state= state
      this.tips= tips
    },
  },
  mounted() {
    this.dispatchMatch()
  },
  components: {
    fp_title: FPTitle,
    title_button: TitleButton,
    logos: Logos,
    my_button: MyButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg{
  background-image: url('/oss/aialgorithm/images/frontpage/header2026.webp');
  background-repeat: no-repeat;
  background-size: 165vw;
  background-position-x: -4vw;
}
.header{
  height: 100vh;
  /* background-image: url(~@/assets/image/frontpage/header.png); */
  /*
     background: repeating-linear-gradient(
     40deg,
     rgba(0, 0, 0, .9) 0, rgba(0, 0, 0, .9) 0.2%,
     rgba(0, 0, 0, 0.6) 0.2%, rgba(0, 0, 0, 0.6) 0.5%
     );
   */

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.tips{
  position: relative;
  font-size: 1.1vw;
  color: 'black';
  /* color: #ff4; */
  /* color: white; */
}
.notice{
  color: red;
  text-align: center;
  margin-top: .5vw;
}
.test{
  position: absolute;
  left: 10vw;
  top: 10vh;
  width: 5em;
  height: 2em;
  color: white;
  background: red;
}
.video {
  /* position: absolute;
     right: 30%;
     margin-top: 30.5vw; */
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content:space-around;
}
.year {
  text-align: center;
  margin-top: 55vh;
  font-size: 84px;
  font-weight: 800;
  color: black;
}
</style>
